var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',{attrs:{"items":_vm.processes,"label":_vm.$t(_vm.schema.name),"dense":"","filled":""},model:{value:(_vm.localeValue),callback:function ($$v) {_vm.localeValue=$$v},expression:"localeValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }